import befehleDE from '../locales/de/befehle.json'
import commonDE from '../locales/de/common.json'
import componentsDE from '../locales/de/components.json'
import initDE from '../locales/de/init.json'
import validationDE from '../locales/de/validation.json'

export const uiResources = {
  de: {
    befehle: befehleDE,
    common: commonDE,
    components: componentsDE,
    init: initDE,
    validation: validationDE
  }
} as const
